import { render, staticRenderFns } from "./CampaignNotification.vue?vue&type=template&id=66e82093"
import script from "./CampaignNotification.vue?vue&type=script&lang=js"
export * from "./CampaignNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports